import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentePubliceComponent } from './documente-publice.component';
import { AddDocumentePubliceComponent } from './add-documente-publice/add-documente-publice.component';
import { EditDocumentePubliceComponent } from './edit-documente-publice/edit-documente-publice.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';

@NgModule({
    declarations: [
        DocumentePubliceComponent,
        AddDocumentePubliceComponent,
        EditDocumentePubliceComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        NgxMatTimepickerModule
    ],
    exports: [DocumentePubliceComponent]
})
export class DocumentePubliceModule { }
